import _ from 'lodash';

const hasLoginPage = 'HAS_LOGIN_PAGE';


export const setHasLoginPage = (val) => {
    _.set(window, hasLoginPage, val);
};

export const getHasLoginPage = () => {
    return _.get(window, hasLoginPage, false);
};
